import { render, staticRenderFns } from "./UploadBtnDynamic.vue?vue&type=template&id=68b32a56"
import script from "./UploadBtnDynamic.vue?vue&type=script&lang=js"
export * from "./UploadBtnDynamic.vue?vue&type=script&lang=js"
import style0 from "./UploadBtnDynamic.vue?vue&type=style&index=0&id=68b32a56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports